import { baseURL } from '@/api';

export default ({
  methods: {
    getImage(image) {
      return `${baseURL}/${image}`;
    },
  },
});
